var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMessagesPrimaryActive = function SvgMessagesPrimaryActive(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.8V2.4C0 1.07452 1.07452 0 2.4 0H13.6C14.9255 0 16 1.07451 16 2.4V12.8C16 14.1255 14.9255 15.2 13.6 15.2H2.4C1.07452 15.2 0 14.1255 0 12.8ZM9.54959 9.60011C9.37196 10.2902 8.74553 10.8001 8 10.8001C7.25447 10.8001 6.62804 10.2902 6.45041 9.60011H3.2C2.75817 9.60011 2.4 9.24194 2.4 8.80011V3.20011C2.4 2.75829 2.75817 2.40011 3.2 2.40011H12.8C13.2418 2.40011 13.6 2.75829 13.6 3.20011V8.80011C13.6 9.24194 13.2418 9.60011 12.8 9.60011H9.54959Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMessagesPrimaryActive, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/messages-primary-active.e51cb82f.svg";
export { ForwardRef as ReactComponent };